import {
  DataTablePrimeReact,
  PaginationERP,
  PaginationERPProps,
  TableERP,
} from "@finanedi.es/storybook"
import { SumaSaldoInformeDtoProps } from "api/DTOs/SumaSaldoInformeDto"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import { SUMAS_SALDOS_COLUMNS_GROUP } from "features/Contabilidad/pages/SumasSaldos/SumasSaldos.columnGroup"
import { SUMAS_SALDOS_COLUMNS } from "features/Contabilidad/pages/SumasSaldos/sumasSaldos.columns"
import { useTranslation } from "react-i18next"

export const SumasYSaldosTable = ({
  dtRef,
  setPagination,
  items,
  totalCount,
  isLoading,
  pagination,
}: {
  dtRef: React.MutableRefObject<DataTablePrimeReact<
    SumaSaldoInformeDtoProps[]
  > | null>
  setPagination: React.Dispatch<React.SetStateAction<PaginationERPProps>>
  items?: SumaSaldoInformeDtoProps[] | null
  totalCount?: number
  isLoading?: boolean
  pagination: { itemsPerPage: number; skipCount: number }
}) => {
  const { t } = useTranslation()
  return (
    <div className='tw-flex tw-flex-col tw-h-[calc(100%-140px)] tw-relative '>
      <div className='tw-h-full tw-min-h-0'>
        <TableERP
          refTable={dtRef}
          headerColumnGroup={SUMAS_SALDOS_COLUMNS_GROUP(t)}
          columns={SUMAS_SALDOS_COLUMNS}
          className='tw-h-full !tw-z-0'
          columnResizeMode='expand'
          removableSort
          value={items ?? []}
          showGridlines
          lazy
          dataKey='id'
          scrollable
          size='small'
          loading={isLoading}
          emptyMessage={t("primeReact.table.emptyMessage")}
        />
        <PaginationERP
          className={PAGINATION_STYLES}
          totalRecords={totalCount}
          first={pagination.skipCount}
          rows={pagination.itemsPerPage}
          resetScroll={() => {
            dtRef.current && dtRef.current?.resetScroll()
          }}
          setPagination={setPagination}
          optionDropdown={[10, 20, 50, 100]}
          texts={{
            textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
            textCurrentPageReport: `${t("pagination.from")}`,
          }}
        />
      </div>
    </div>
  )
}
